import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LayoutModule } from '../../../layout/modules';
import { SurveyFilters } from './filters';
import { SurveyList } from './list';
import { SURVEYS_NEW } from '../../../../routes/paths';
import { SurveyFilter } from './filters/props';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { typesRedux } from '../../../../shared/types/typesRedux';

export const Surveys = () => {
    const dispatch = useDispatch();
    const [filters, setFilters] = useState<SurveyFilter>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    useEffect(() => {
        // Reset stepper when entering the list
        dispatch({ type: typesRedux.resetStepper });
    }, []);

    return (
        <>
            <LayoutModule
                title="Búsqueda de encuestas"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SURVEYS_NEW,
                        }}
                    />
                }
            >
                <SurveyFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <SurveyList filters={filters} />
        </>
    );
};
